import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { IconLink, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const BundleCloseButton = (props: Props) => {
  const { disabled, onPress } = props;

  const { formatMessage } = useIntl();

  return (
    <IconLink
      name="IconClose"
      palette="white"
      width={CLOSE_BUTTON_SIZE}
      height={CLOSE_BUTTON_SIZE}
      iconSize={CLOSE_ICON_SIZE}
      aria-label={formatMessage(messages.close)}
      disabled={disabled}
      style={styles.closeButton}
      onPress={onPress}
    />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CLOSE_BUTTON_SIZE = 40;
const CLOSE_BUTTON_INSET = theme.spacing['4'];
const CLOSE_ICON_SIZE = 24;
const CLOSE_BUTTON_SHADOW = '0px 8px 40px 4px rgba(14, 21, 14, 0.09)';

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  closeButton: {
    position: 'absolute',
    top: CLOSE_BUTTON_INSET,
    right: CLOSE_BUTTON_INSET,
    boxShadow: CLOSE_BUTTON_SHADOW,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  close: {
    defaultMessage: 'Close',
    description: 'Bundle | Header | Close button accessibility label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  disabled?: boolean;
  onPress: () => void;
};
